import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { Label } from '@/components/ui/label'

interface FieldProps {
    label: ReactNode
    htmlFor?: string
    required?: boolean
    hint?: ReactNode
    error?: string | null
    action?: ReactNode
    className?: string
    children: ReactNode
}

const Field: FC<FieldProps> = ({
    label,
    htmlFor,
    required = false,
    hint,
    error,
    action,
    className,
    children
}): ReactNode => {
    return (
        <div className={cn('flex min-w-0 flex-col gap-1.5', className)}>
            <div className='flex min-h-5 items-center justify-between gap-2'>
                <Label htmlFor={htmlFor} className='gap-1 text-[13px] font-medium text-foreground'>
                    {label}

                    {required && (
                        <span className='text-destructive' aria-hidden='true'>
                            *
                        </span>
                    )}
                </Label>

                {action}
            </div>

            {children}

            {error ? (
                <p role='alert' className='text-xs font-medium text-destructive'>
                    {error}
                </p>
            ) : hint ? (
                <p className='text-xs text-muted-foreground'>
                    {hint}
                </p>
            ) : null}
        </div>
    )
}

export default Field
